module.exports = __webpack_public_path__ + "static/media/conlicitago.0d6b13bc.svg";